module.exports = __webpack_public_path__ + "assets/img/serve5.e13270c2.png";